import React, { useContext } from 'react';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import FooterTab from './FooterTab';
import {
  FooterContainer,
  FooterLink,
  FooterDisclaimer,
  FooterWrapper,
  FooterAccoladesItemImg,
  FooterAccolades,
  FooterAccoladesItem,
  FooterRow,
  FooterSocial,
  FooterSocialItem,
  FooterSocialItemImg,
  FooterCopyright,
  FooterGenNav,
  FooterGenNavList,
  FooterGenNavListItem,
  FooterGenNavListItemLink,
  FooterBrandLogos,
  HeaderLogoLink,
  HeaderLogoLinkImg,
  FooterLogo,
  FooterLogoLink,
  FooterLogoLinkImg,
  FooterNavigation,
} from './styles';

/**
 * Footer
 *
 * Basic footer used throughout the app.
 */

const thisYear = new Date().getFullYear();

const Footer = () => {
  const { universalNavigation } = useContext(CruiseSearchContext);

  const navigationFooter = universalNavigation?.components.footer;

  const getKey = index => `item_${index}`;

  return (
    <FooterContainer id="rciFooter">
      <FooterWrapper>
        <FooterRow>
          <FooterDisclaimer>
            {navigationFooter?.termsAndConditions?.label
              ? `${navigationFooter?.termsAndConditions.label} `
              : '*Please see all applicable Terms & Conditions for Promotions '}
            <FooterLink
              href={
                navigationFooter?.termsAndConditions?.pathLink ||
                'https://www.royalcaribbean.com/terms-and-conditions/promotions'
              }
            >
              {navigationFooter?.termsAndConditions?.labelLink || 'here'}
            </FooterLink>
            .
          </FooterDisclaimer>
        </FooterRow>
        <FooterRow>
          <FooterAccolades>
            {navigationFooter?.accolades.map(e => (
              <FooterAccoladesItem key={e.altText}>
                <FooterAccoladesItemImg src={e.src} alt={e.altText} />
              </FooterAccoladesItem>
            ))}
          </FooterAccolades>
        </FooterRow>
        <FooterRow>
          <FooterNavigation>
            {navigationFooter?.mainMenu.children.map((e, index) => (
              <FooterTab data={e} key={getKey(index)} />
            ))}
          </FooterNavigation>
        </FooterRow>
        <FooterRow>
          <FooterSocial>
            {navigationFooter?.socialMedia.children.map(e => (
              <FooterSocialItem key={e.altText} href={e.path}>
                <FooterSocialItemImg src={e.src} alt={e.altText} />
              </FooterSocialItem>
            ))}
          </FooterSocial>
        </FooterRow>
        <FooterRow>
          <FooterCopyright>
            &copy; {thisYear} Royal Caribbean International
          </FooterCopyright>
        </FooterRow>
      </FooterWrapper>
      <FooterRow>
        <FooterGenNav>
          <FooterGenNavList>
            {navigationFooter?.supportMenu.children.map(e => (
              <FooterGenNavListItem key={e.label}>
                <FooterGenNavListItemLink href={e.path}>
                  {e.label}
                </FooterGenNavListItemLink>
              </FooterGenNavListItem>
            ))}
          </FooterGenNavList>
        </FooterGenNav>
      </FooterRow>
      <FooterRow>
        <FooterBrandLogos>
          <HeaderLogoLink
            key={navigationFooter?.company.altText}
            href={navigationFooter?.company.path}
          >
            <HeaderLogoLinkImg
              id={navigationFooter?.company.altText}
              src={navigationFooter?.company.src}
              alt={navigationFooter?.company.altText}
            />
          </HeaderLogoLink>
          <FooterLogo>
            {navigationFooter?.company.children.map(e => (
              <FooterLogoLink key={e.altText} href={e.path}>
                <FooterLogoLinkImg src={e.src} alt={e.altText} />
              </FooterLogoLink>
            ))}
          </FooterLogo>
        </FooterBrandLogos>
      </FooterRow>
    </FooterContainer>
  );
};

export default Footer;
